import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { CourseType } from 'src/app/model/course-type';

@Injectable({
  providedIn: 'root'
})
export class CoursetypeEntityService extends EntityCollectionServiceBase<CourseType> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
      super('CourseType', serviceElementsFactory);
  }
}
